import { render, staticRenderFns } from "./EcommerceRevenueChart.vue?vue&type=template&id=d2dabc1a&scoped=true&"
import script from "./EcommerceRevenueChart.vue?vue&type=script&lang=js&"
export * from "./EcommerceRevenueChart.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceRevenueChart.vue?vue&type=style&index=0&id=d2dabc1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2dabc1a",
  null
  
)

export default component.exports